module.exports = __webpack_public_path__ + "images/crying-loudly.png";